import { FC } from "react";
import { Reminder } from "@models/reminder";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import StyledTableContainer from "@components/StyledTable";
import TableBody from "@mui/material/TableBody";
import { useTranslation } from "react-i18next";
import ReminderRow from "@components/ReminderList/ReminderRow";

const ReminderList: FC<{
  reminders: Reminder[];
  onEdit: (reminder: Reminder) => void;
  onSelect: (reminder: Reminder) => void;
  onEnabledChange: (reminder: Reminder) => void;
  selectedReminderIds: Set<String>;
}> = ({
  reminders,
  onEnabledChange,
  onEdit,
  onSelect,
  selectedReminderIds,
}) => {
  const { t } = useTranslation();
  return (
    <StyledTableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableContainer.StyledTableCell />
            <StyledTableContainer.StyledTableCell>
              {t("schedule.list.title")}
            </StyledTableContainer.StyledTableCell>
            <StyledTableContainer.StyledTableCell>
              {t("schedule.list.type")}
            </StyledTableContainer.StyledTableCell>
            <StyledTableContainer.StyledTableCell>
              {t("schedule.list.date")}
            </StyledTableContainer.StyledTableCell>
            <StyledTableContainer.StyledTableCell>
              {t("schedule.list.enabled")}
            </StyledTableContainer.StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reminders?.map((reminder) => (
            <ReminderRow
              selected={selectedReminderIds.has(reminder.id)}
              onSelect={() => onSelect(reminder)}
              onEdit={() => onEdit(reminder)}
              onEnabledChange={() => onEnabledChange(reminder)}
              reminder={reminder}
              key={reminder.id}
            />
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default ReminderList;
